import { Action, SubscribedProductTypesType } from '../Type';
import { ProductType } from '@pages/product-analyzer/Product';
import { Dispatch } from 'redux';

export const addSubscribedProductType = (payload: ProductType) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: SubscribedProductTypesType.SubscribedProductTypeAdded,
      payload,
    });
  };
};

export const clearSubscribedProductType = () => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: SubscribedProductTypesType.SubscribedProductTypesCleared,
    });
  };
};
